import Navbar from "../Components/Navbar";
import Title from "./Home/Title";
import SectionStartBackground from "./Home/SectionStartBackground";
import HorizontalScrollBackground from "./Home/HorizontalScrollBackground";
import SectionStartKnowledge from "./Home/SectionStartKnowledge";
import HorizontalScrollKnowledge from "./Home/HorizontalScrollKnowledge";
import SectionStartWorkflow from "./Home/SectionStartWorkflow";
import HorizontalScrollWorkflow from "./Home/HorizontalScrollWorkflow";
import SectionStartImpact from "./Home/SectionStartImpact";
import HorizontalScrollImpact from "./Home/HorizontalScrollImpact";
import SectionStartSponsor from "./Home/SectionStartSponsor";
import DetailSponsor from "./Home/DetailSponsor";
import BottomHomepage from "./Home/BottomHomepage";
import Footer from "../Components/Footer";

export default function Home(){
    return(
        <div>
            <div className="relative mb-8">
                <div className="fixed top-0 left-0 w-screen z-50">
                    <Navbar/>
                </div>
                <Title />
            </div>
            <SectionStartBackground />
            <HorizontalScrollBackground />
            <SectionStartKnowledge />
            <HorizontalScrollKnowledge />
            <SectionStartWorkflow />
            <HorizontalScrollWorkflow />
            <SectionStartImpact />
            <HorizontalScrollImpact />
            <SectionStartSponsor />
            <DetailSponsor />
            <BottomHomepage />
            <Footer />
        </div>
    )
}